export const GENDERS = [["mare", "Mare"], ["gelding", "Gelding"], ["stallion", "Stallion"], ["colt", "Colt"], ["filly", "Filly"]];
export const BREEDS = [
  ["aqha", "Quarter Horse (AQHA)"], ["apha", "Paint Horse (APHA)"], ["appaloosa", "Appaloosa"],
  ["thoroughbred", "Thoroughbred"], ["arabian", "Arabian"], ["warmblood", "Warmblood"], ["draft", "Draft"],
  ["pony", "Pony"], ["grade", "Grade"], ["other", "Other"],
];
export const DISCIPLINES = [
  ["tie_down_roping", "Tie-Down Roping"], ["breakaway_roping", "Breakaway Roping"],
  ["team_roping_heading", "Team Roping - Heading"], ["team_roping_heeling", "Team Roping - Heeling"],
  ["barrel_racing", "Barrel Racing"], ["pole_bending", "Pole Bending"], ["cutting", "Cutting"], ["reining", "Reining"],
  ["reined_cow_horse", "Reined Cow Horse"], ["ranch_horse", "Ranch Horse"], ["ranch_riding", "Ranch Riding"],
  ["trail_riding", "Trail Riding"], ["western_pleasure", "Western Pleasure"], ["english", "English"],
  ["all_around", "All-Around"], ["prospect", "Prospect"], ["other", "Other"],
];

export const CURRENCIES = [["CAD", "CAD — Canadian Dollars"], ["USD", "USD — US Dollars"]];
export const currencyFor = (country) => (country === "US" ? "USD" : "CAD");
export const formatPrice = (n) => (n === null || n === undefined || n === "" ? "" : `$${Number(n).toLocaleString("en-US")}`);
export const priceLabel = (h) => {
  if (typeof h.expected_price === "number") return `${formatPrice(h.expected_price)} ${h.price_currency || "CAD"}`;
  if (h.expected_price_legacy) return `${h.expected_price_legacy} (needs numeric price)`;
  if (typeof h.expected_price === "string") return h.expected_price;
  return "";
};

const label = (list, v) => (list.find(([k]) => k === v) || [null, v])[1];
export const genderLabel = (v) => (v ? label(GENDERS, v) : "");
export const breedLabel = (h) => (!h.breed ? "" : h.breed === "other" ? `Other — ${h.breed_other || "not specified"}` : label(BREEDS, h.breed));
export const disciplineLabels = (h) => (h.disciplines || []).map((d) => (d === "other" ? `Other — ${h.discipline_other || "not specified"}` : label(DISCIPLINES, d)));
